export enum FieldIcon {
  CHEVRON_DOWN = 'fa-solid fa-chevron-down',
  CHEVRON_RIGHT = 'fa-solid fa-chevron-right',
  EYE = 'fa-regular fa-eye',
  EYE_SLASH = 'fa-regular fa-eye-slash'
}
